import React, { useEffect, useState } from 'react'

const useLocalStorageListener = (key) => {
  const [value, setValue] = useState(() => localStorage.getItem(key));

  useEffect(() => {
    const handleStorageChange = () => {
      const newValue = localStorage.getItem(key);
      setValue(newValue);
    };


    window.addEventListener("storage", handleStorageChange);


    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (k, v) {
      originalSetItem.call(this, k, v);
      if (k === key) {
        window.dispatchEvent(new Event("storage"));
      }
    };

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      localStorage.setItem = originalSetItem;
    };
  }, [key]);

  return value;
};

export default useLocalStorageListener